import { connect } from "react-redux";
import get from "lodash/get";

import {
  getWinterAreas as onGetWinterAreas,
  setWinterGroupFilter as onSetWinterGroupFilter,
  setWinterAreasFilter as onSetWinterAreasFilter,
  getWinterCompaniesRoutes as onGetWinterCompaniesRoutes,
  setWinterSensorssFilter as onSetWinterSensorssFilter,
  setWinterRouteSmoothFactor as onSetWinterRouteSmoothFactor,
  setWinteCompaniesInfo as onSetWinteCompaniesInfo,
  searchTermWinterUnit as onSearchTermWinterUnit,
  setWinterPoupup as onSetWinterPoupup,
  setRouteOrReportMode as onSetRouteOrReportMode,
  winterReportDownload as onWinterReportDownload,
  winterEOSKReportDownload as onWinterEOSKReportDownload,
  setGeozoneSearch as onSetGeozoneSearch,
  getWinterAreasSimple as onGetWinterAreasSimple,
  winterShortEOSKReportDownload as onWinterShortEOSKReportDownload,
} from "../../actions/winterMaintenceAction";

const mapStateToProps = (state) => ({
  winterAreasDataState: state.winterMaintence.winterAreasDataState,
  winterAreasSimpleDataState: state.winterMaintence.winterAreasSimpleDataState,
  winterCompaniesRoutesDataState: state.winterMaintence.winterCompaniesRoutesDataState,
  winterReportDownloadDataStrate: state.winterMaintence.winterReportDownloadDataStrate,
  winterEOSKReportDownloadDataStrate: state.winterMaintence.winterEOSKReportDownloadDataStrate,
  winterShortEOSKReportDownloadDataStrate: state.winterMaintence.winterShortEOSKReportDownloadDataStrate,
  timeCompaniesRoutesRequest: get(state, ["winterMaintence", "timeCompaniesRoutesRequest"], null),
  winterAreas: get(state, ["winterMaintence", "winterAreas"], []),
  winterAreasSimple: get(state, ["winterMaintence", "winterAreasSimple"], []),
  winterGroups: get(state, ["winterMaintence", "winterGroups"], []),
  winterWithoutGroupsFilter: get(state, ["winterMaintence", "winterWithoutGroupsFilter"], true),
  winterGroupsFilter: get(state, ["winterMaintence", "winterGroupsFilter"], []),
  winterAreasFilter: get(state, ["winterMaintence", "winterAreasFilter"], []),
  winterAreasGetData: get(state, ["winterMaintence", "winterAreasGetData"], new Date()),
  winterSensorsFilter: get(state, ["winterMaintence", "winterSensorsFilter"], {
    filterDump1: false,
    filterDump2: false,
    filterSand: false,
    dump: true,
    sand: true,
    dumpColor: "#000000",
    dump2Color: "#4368adff",
    sandColor: "#df8d21",
  }),
  winterRouteUnitsProcess: get(state, ["winterMaintence", "winterRouteUnitsProcess"], 0),
  winterRouteSmoothFactor: get(state, ["winterMaintence", "winterRouteSmoothFactor"], 3),
  winterDashboard: get(state, ["winterMaintence", "winterDashboard"], null),
  winterPoupup: get(state, ["winterMaintence", "winterPoupup"], { dataPoupup: null, positionPoupup: null }),
  openCompaniesInfoState: get(state, ["winterMaintence", "openCompaniesInfoState"], 0),
  searchTermWinterUnit: get(state, ["winterMaintence", "searchTermWinterUnit"], ""),
  findUnitPosition: get(state, ["winterMaintence", "findUnitPosition"], null),
  isReportMode: get(state, ["winterMaintence", "isReportMode"], false),
  searchGeoZone: get(state, ["winterMaintence", "searchGeoZone"], null),
  colorParentCompanies: get(state, ["winterMaintence", "colorParentCompanies"], null),
  regionTitle: get(state, ["winterMaintence", "regionTitle"], null),
  errors: get(state, ["winterMaintence", "errors"], null),
});

const mapDispatchToProps = {
  onGetWinterAreas,
  onGetWinterAreasSimple,
  onSetWinterGroupFilter,
  onSetWinterAreasFilter,
  onGetWinterCompaniesRoutes,
  onSetWinterSensorssFilter,
  onSetWinterRouteSmoothFactor,
  onSetWinteCompaniesInfo,
  onSearchTermWinterUnit,
  onSetWinterPoupup,
  onSetRouteOrReportMode,
  onWinterReportDownload,
  onSetGeozoneSearch,
  onWinterEOSKReportDownload,
  onWinterShortEOSKReportDownload,
};

const withWinterMaintence = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withWinterMaintence };
